import { go, map, filter, identity } from 'fxjs/es';

const FACTORY_TYPE = {
  /* 메인 */
  home: 'home',
  /* 상품리스트, 상품만들기내 상품리스트, 검색 */
  list: 'list',
  /* 단체굿즈/판촉 */
  biz: 'biz',
  /* 베스트, 마이페이지 베스트 */
  best: 'best',
  /* 뱃지 표시 안함 */
  // null: null
};

const BADGE_TYPE = {
  biz: 'biz' /* 단체굿즈/판촉 */,
  order_quantity: 'order_quantity' /* 누적 판매량 */,
  sale: 'sale' /* 할인 */,
  bp_first: 'bp_first' /* 마플 ___ 1위 */,
  review: 'review' /* 리뷰 개수 */,
  moq: 'moq' /* n개 이상 (최소 주문 수량 표시) */,
  custom_badge: 'custom_badge' /* 공법 (커스텀 뱃지) */,
  best: 'best',
  new: 'new',
};

// Badge 우선순위 별로 TAG_TYPE 과 함께 나열
const BADGE_FACTORY = {
  [FACTORY_TYPE.home]: [],
  [FACTORY_TYPE.list]: [
    BADGE_TYPE.biz,
    BADGE_TYPE.custom_badge,
    BADGE_TYPE.bp_first,
    BADGE_TYPE.sale,
    BADGE_TYPE.new,
  ],
  [FACTORY_TYPE.biz]: [
    BADGE_TYPE.biz, // biz 목록 불러오기의 경우 별도의 데이터 검사 로직 없이 바로 뱃지 표시
    BADGE_TYPE.custom_badge,
    BADGE_TYPE.bp_first,
    BADGE_TYPE.sale,
    BADGE_TYPE.new,
  ],
  [FACTORY_TYPE.best]: [
    BADGE_TYPE.order_quantity,
    BADGE_TYPE.biz,
    BADGE_TYPE.custom_badge,
    BADGE_TYPE.bp_first,
    BADGE_TYPE.sale,
    BADGE_TYPE.best,
    /* BADGE_TYPE.review // bp.review_count 를 측정후 generateBadge 수동 호출중임 */
  ],
  null: [],
};

export const generateBadge = ({
  factory_type,
  badge_type: type,
  bp_first,
  is_mobile,
  is_discount,
  discount_ranges,
  bp,
}) => {
  switch (type) {
    case BADGE_TYPE.order_quantity:
      if (bp.order_quantity > 9999) {
        return { color: 'wht', text: TT('product::list::list_11_1'), type };
      }
      return null;
    case BADGE_TYPE.sale:
      if (is_discount) {
        return { color: 'og', text: 'Sale', type };
      }
      return null;
    case BADGE_TYPE.bp_first:
      if (bp_first) {
        return {
          color: 'og',
          text: is_mobile
            ? 'Category Best'
            : TT('product::list::list_10_1', { name: bp_first['name' + G._en] }),
          type,
        };
      }
      return null;
    case BADGE_TYPE.review:
      // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      // 해당 tag type 을 이용하려면 bp.review_count 를 측정해 주어야 함.
      // TAG_ENABLED 에서 직접 사용하지 않고 bp.review_count 를 측정한 다음 직접 추가
      if (bp.review_count) {
        return {
          color: 'wht',
          text: TT('common::review_count', {
            count: bp.review_count > 999 ? '999+' : bp.review_count,
          }),
          type,
        };
      }
      return null;
    case BADGE_TYPE.moq:
      if (discount_ranges.is_moq) {
        return {
          color: 'wht',
          text: TT('cell::product::prod_1_6', { n: discount_ranges.price_ranges[0]?.start || 1 }),
          type,
        };
      }
      return null;
    case BADGE_TYPE.custom_badge:
      if (bp._?.base_products_custom_badges?.length) {
        const result = bp._.base_products_custom_badges.find(({ name }) => true);
        if (result) return { color: 'wht', text: result.name, type };
      }
      return null;
    case BADGE_TYPE.biz:
      if (factory_type === FACTORY_TYPE.biz || (bp._?.biz_product && Object.keys(bp._.biz_product).length)) {
        return {
          color: 'skyblue',
          text: is_mobile ? TT('product::list::list_21_2') : TT('product::list::list_21_1'),
          type,
        };
      }
      return null;
    case BADGE_TYPE.best:
    case BADGE_TYPE.new:
      for (const { name } of bp._.base_product_tags) {
        const _type = name.toLowerCase();
        if (type == _type) return { color: 'bk', text: name, type };
      }
      return null;
  }
  return null;
};

export const getBadges = (factory_type, props) => {
  return go(
    BADGE_FACTORY[factory_type],
    map((badge_type) =>
      generateBadge({
        ...props,
        badge_type,
        factory_type,
      }),
    ),
    filter(identity),
  );
};
